var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { usersApi } from 'apis/users';
import { api } from 'utils/apis/api';
export const contactsApi = api.injectEndpoints({
    endpoints: (builder) => ({
        mergeContacts: builder.mutation({
            query: ({ target, sources, strategy, dryRun }) => ({
                version: 1,
                method: 'POST',
                path: `contacts/merge`,
                params: {
                    dryRun,
                },
                body: { target, sources, strategy },
            }),
            onQueryStarted({ dryRun }, { dispatch, queryFulfilled }) {
                return __awaiter(this, void 0, void 0, function* () {
                    try {
                        const { data: { data: contact }, } = yield queryFulfilled;
                        if (!dryRun) {
                            dispatch(usersApi.util.updateQueryData('readUser', { id: contact.id }, (draft) => {
                                const mutableUser = draft.data;
                                for (const [key, value] of Object.entries(contact)) {
                                    mutableUser[key] = value;
                                }
                            }));
                        }
                    }
                    catch (_a) {
                        /* do nothing */
                    }
                });
            },
        }),
    }),
});
